import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const difficultyLevelAddApi = createAsyncThunk(
    'auth/difficulty-level/add',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.difficultyLevelList, data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const difficultyLevelAddSlice = createSlice({
    name: 'difficulty-level Add',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(difficultyLevelAddApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(difficultyLevelAddApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(difficultyLevelAddApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const difficultyLevelAddReducer = difficultyLevelAddSlice.reducer